module.exports = __webpack_public_path__ + "static/media/ConpamyProfile_color.d634dce5.svg";